//@ts-check
import FieldBase from './FieldBase';
import { FieldArray } from 'react-final-form-arrays';
import { FormSpy, Field } from 'react-final-form';
import Provider from '../containers/Provider';
import Page from '../containers/Page';
import Dialog from '../containers/Dialog';
import Fragment from '../containers/Fragment';
import Error, { FORM_ERROR } from '../Error';
import Condition from '../Condition';
import TextField, { Text, Number, Name, Description, Email, Password, Domain } from './Text';
import SwitchField, { Switch } from './Switch';
import { LocalFile } from './LocalFile';
import SelectField, { Select } from './Select';
import DateTimeFormField, { DateTime } from './DateTime';
import XPathField, { XPath } from './XPath';
import CheckboxFormField, { Checkbox } from './Checkbox';
import RadioGroupField, { RadioGroup } from './RadioGroup';
import { MultiSelect } from './MultiSelect';
import DataSelectFormField, { DataSelect } from './DataSelect';
import DiagramSelectFormField, { DiagramSelect } from './DiagramSelect';
import DataGridSelectFormField, { DataGridSelect } from './DataGridSelect';
import SignatureFormField, { Signature } from './Signature';
import RatingFormField, { Rating } from './Rating';
import FilterFormField, { Filter } from './Filter';
import RepositoryPickerFormField, { RepositoryPicker } from './RepositoryPicker';
import Input from '../input';
import Validators from '../validators';
import BlockPrompt from '../BlockPrompt';
var Form = {
  Provider: Provider,
  Field: FieldBase,
  //backward compatibility, will be removed in next versions
  FieldBase: FieldBase,
  FieldArray: FieldArray,
  Spy: FormSpy,
  SpyField: Field,
  Page: Page,
  Dialog: Dialog,
  Fragment: Fragment,
  Validators: Validators,
  Fields: {
    Text: Text,
    Number: Number,
    Name: Name,
    Description: Description,
    Email: Email,
    Password: Password,
    Domain: Domain,
    Switch: Switch,
    Select: Select,
    MultiSelect: MultiSelect,
    Checkbox: Checkbox,
    RadioGroup: RadioGroup,
    DateTime: DateTime,
    XPath: XPath,
    Signature: Signature,
    Filter: Filter,
    DataSelect: DataSelect,
    DataGridSelect: DataGridSelect,
    DiagramSelect: DiagramSelect,
    Rating: Rating,
    RepositoryPicker: RepositoryPicker,
    LocalFile: LocalFile
  },
  Input: Input,
  TextField: TextField,
  Switch: SwitchField,
  Select: SelectField,
  DateTime: DateTimeFormField,
  XPath: XPathField,
  Checkbox: CheckboxFormField,
  RadioGroup: RadioGroupField,
  DataSelect: DataSelectFormField,
  DiagramSelect: DiagramSelectFormField,
  DataGridSelect: DataGridSelectFormField,
  Signature: SignatureFormField,
  Rating: RatingFormField,
  Filter: FilterFormField,
  RepositoryPicker: RepositoryPickerFormField,
  BlockPrompt: BlockPrompt,
  Error: Error,
  Condition: Condition,
  ERROR: FORM_ERROR
};
export default Form;